var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popover',{attrs:{"trigger":_vm.trigger,"visible":_vm.optionsVisible},on:{"visibleChange":_vm.handleClickChange}},[_c('template',{slot:"content"},[_vm._t("content")],2),_c('span',{staticStyle:{"user-select":"none"},style:({color:_vm.scolor})},[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }